import { render, staticRenderFns } from "./veSbzcZcAllocateEdit.vue?vue&type=template&id=45f7c20e&scoped=true"
import script from "./veSbzcZcAllocateEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcAllocateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f7c20e",
  null
  
)

export default component.exports